import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { Flag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

const reasons = [
  { value: "virus" as const, label: "Vírus / Malware" },
  { value: "spam" as const, label: "Spam" },
  { value: "inappropriate" as const, label: "Conteúdo inapropriado" },
];

const ReportButton = ({ productId, variant = "ghost" }: { productId: string; variant?: "ghost" | "outline" }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleReport = async (reason: "virus" | "spam" | "inappropriate") => {
    if (!user) { toast.error("Faça login para denunciar"); return; }
    setLoading(true);
    const { error } = await supabase.from("reports").insert({
      product_id: productId,
      user_id: user.id,
      reason,
    } as any);
    setLoading(false);
    if (error?.code === "23505") {
      toast.info("Você já denunciou este produto.");
    } else if (error) {
      toast.error("Erro ao enviar denúncia");
    } else {
      toast.success("Denúncia enviada. Obrigado por ajudar a manter a plataforma segura.");
    }
    setOpen(false);
  };

  return (
    <>
      <Button variant={variant} size="sm" onClick={() => setOpen(true)} className="text-muted-foreground hover:text-destructive">
        <Flag className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xs">
          <DialogHeader>
            <DialogTitle>Denunciar Produto</DialogTitle>
          </DialogHeader>
          <div className="space-y-2">
            {reasons.map((r) => (
              <Button
                key={r.value}
                variant="outline"
                className="w-full justify-start"
                disabled={loading}
                onClick={() => handleReport(r.value)}
              >
                {r.label}
              </Button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ReportButton;
